export const learningTimeToText = (learningTime) => {
  switch (learningTime) {
    case "FIVE_TO_TWENTY_MIN":
      return "5-20 min";

    default:
      return "";
  }
};
